import axios from "axios";
import { imgURL } from "../apiConfig";
import React, { useEffect, useState } from "react";
import { AiOutlineEye } from "react-icons/ai";

const Gallery = () => {
  //integrating get method
  const [AddGalery, setAddGalery] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  const getAddGallery = async () => {
    try {
      let res = await axios.get("/api/user/getgallery");
      if (res.status === 200) {
        setAddGalery(res.data.getgallery);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAddGallery();
  }, []);

  return (
    <>
      <div className="">
        <div
          className="module mid"
          style={{
            height: "80px",
            background: "#d1ccc0",
            overflow: "hidden",
            backgroundSize: "cover",
          }}
        >
          <h2>Gallery</h2>
          <ul
            className="container breadcrumbs bc3 pt-3 pb-3"
            role="menubar"
            aria-label="breadcrumbs"
          >
            <li>
              <a href="/">Home</a>{" "}
              <span style={{ color: "#092746" }}>&raquo;</span>
            </li>
            <li style={{ color: "#092746" }}> Gallery</li>
          </ul>
        </div>
      </div>

      <div className="container mt-4">
        <div className="row hjklo_9">
          {AddGalery?.map((item, index) => {
            return (
              <div className="col-md-3 text-center hhjou_0 mb-4" key={index}>
                <div
                  style={{ position: "relative", cursor: "pointer" }}
                  onClick={() => setSelectedImage(item)}
                >
                  <img
                    src={imgURL(`/Gallery/${item?.GImage}`)}
                    alt={item?.GText || ""}
                    style={{
                      width: "100%",
                      height: "250px",
                      objectFit: "cover",
                      borderRadius: "5px",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "250px",
                      backgroundColor: "rgba(0, 0, 0, 0.4)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "5px",
                      opacity: 0,
                      transition: "opacity 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = 0)}
                  >
                    <AiOutlineEye style={{ color: "#fff", fontSize: "40px" }} />
                  </div>
                </div>
                <h5 style={{ fontFamily: "initial" }}>{item?.GText}</h5>
              </div>
            );
          })}
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.85)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            cursor: "pointer",
          }}
          onClick={() => setSelectedImage(null)}
        >
          {/* Close button */}
          <span
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              color: "#fff",
              fontSize: "35px",
              fontWeight: "bold",
              cursor: "pointer",
            }}
            onClick={() => setSelectedImage(null)}
          >
            &times;
          </span>

          {/* Full image */}
          <img
            src={imgURL(`/Gallery/${selectedImage?.GImage}`)}
            alt={selectedImage?.GText || ""}
            style={{
              maxWidth: "90vw",
              maxHeight: "85vh",
              objectFit: "contain",
              borderRadius: "8px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
            }}
            onClick={(e) => e.stopPropagation()}
          />

          {/* Image text */}
          {selectedImage?.GText && (
            <p
              style={{
                position: "absolute",
                bottom: "30px",
                color: "#fff",
                fontSize: "18px",
                textAlign: "center",
                fontFamily: "initial",
              }}
            >
              {selectedImage.GText}
            </p>
          )}
        </div>
      )}
    </>
  );
};

export default Gallery;
